import { StateCreatorType } from '@/types/storeTypes/storeType'
import { VideoPlayerStoreType } from '@/types/storeTypes/videoPlayerStoreTypes'

const videoPlayerStore: StateCreatorType<VideoPlayerStoreType> = (set) => ({
  isFullscreen: false,
  videoControlsVisible: false,
  showVideoControls: () =>
    set(
      (state) => {
        state.player.videoControlsVisible = true
      },
      false,
      'showVideoControls',
    ),
  hideVideoControls: () =>
    set(
      (state) => {
        state.player.videoControlsVisible = false
      },
      false,
      'hideVideoControls',
    ),
  setIsFullscreen: (isFullscreen) =>
    set(
      (state) => {
        state.player.isFullscreen = isFullscreen
        if (isFullscreen) {
          state.player.videoControlsVisible = true
        }
      },
      false,
      'setIsFullscreen',
    ),
})

export default videoPlayerStore
